import React, { createContext, useContext } from 'react';
import { type OptimizelyDecision } from '@optimizely/react-sdk';

export interface UpgradeContextType  {
  growthUpgrade: OptimizelyDecision;
};

export const initialStateDecision: OptimizelyDecision = {
  variationKey: null,
  userContext: {
    id: null,
    attributes: undefined,
  },
  enabled: false,
  variables: {},
  ruleKey: null,
  flagKey: '',
  reasons: [],
};

const defaultUpgradeContext: UpgradeContextType = {
  growthUpgrade: initialStateDecision,
};

export const UpgradeMembershipContext = createContext(
  defaultUpgradeContext
);

export function useUpgradeMembershipContext() {
  const context = useContext(UpgradeMembershipContext);
  if (!context) {
    throw new Error(
      'You must use the UpgradeMembershipProvider in order to consume this context.'
    );
  }
  return context;
}
